import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityActionTemplateByIdSlice } from './get';

export const coreDataSecurityActionTemplateByIdReducers = combineReducers({
	get: getCoreDataSecurityActionTemplateByIdSlice.asyncReducers
});

export const coreDataSecurityActionTemplateByIdWatchers = combineAllWatchers([
	getCoreDataSecurityActionTemplateByIdSlice.asyncWatchers
]);
